module.exports = __webpack_public_path__ + "img/logo-google-analytics.9182ed4c.svg";